module.exports = __webpack_public_path__ + "img/brocoli.9f56d63f.svg";